<template>
    <div>
        <div class="space-web visible-lg visible-md"></div>
        <div class="space-mobil visible-xs visible-sm"></div>
        <!-- Termina Space -->

        <!-- Buscador Movil -->
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
            <div class="busqueda-contenido3 visible-sm visible-xs">
              <form role="form" @submit.prevent="simpleSearch" method="get" >
                <ul class="list-inline">

                  <li style="width: 77%;"><input v-model="simpleSearchInput" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                  <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                  <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada2"><i class="fa fa-plus"></i></button></li>
                </ul>
              </form>
            </div>
            <div class="busq-avanzada">
              <div id="busqavanzada2" class="collapse">
                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="country" v-model="countryIn"  >
                        <option :value="0" selected >-- País --</option>
                        <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                        <option  :value="0"  selected >-- Categoría --</option>
                        <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" name="activity" v-model="activityIn" >
                        <option  :value="0"  selected >-- Actividad --</option>
                        <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                      </select>
                    </div>
                  </div>
                  </form>
              </div>
            </div>
          </div>
            </div>
        </div>

        <!-- Banner Horizontal -->
        <div class="banner visible-lg visible-md animated slideInDown">
            <div class="container">
                <!--<img  src="../assets/images/banner_horizontal.png">
                <img class="visible-xs visible-sm lateral-responsive" src="../assets/images/banner_lateral.png">-->
            </div>
        </div>

        <!-- Contenido -->
        <div class="contenido-resultados" >
            <div class="container">
                <div class="row">
                   <div class="col-md-8 animated slideInLeft">
                        <div class="tabla-resultado">
                            <div class="titulo-resultado">
                              <h4>RESULTADOS</h4>
                            </div>


                            <div class="resultado-busqueda" v-if="(typeof resultSearch !== 'undefined' )  && resultSearch.lenght == 0 "  >
                                <div class="row">
                                    <div class="col-sm-12" align="center">
                                        <h2>No hay resultados de busqueda</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="resultado-busqueda" v-for="(tmpCont,key,index) in resultSearch" v-if="(typeof resultSearch !== 'undefined' )  && resultSearch  " >
                                <div class="row">
                                    <div class="col-md-3" align="center">
                                        <div class="imagen-persona-res" >
                                           <router-link :to="'/'+resultSearch[key]['company'].Module+'/'+resultSearch[key]['company'].IDRecord" class="color">

                                                <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/'+resultSearch[key]['company'].type+'/'+getVerticalContact(resultSearch[key]['company'].Images)+')' }" v-if="resultSearch[key]['company'].Images" ></div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-9 info-resultado">
                                        <router-link :to="'/'+resultSearch[key]['company'].Module+'/'+resultSearch[key]['company'].IDRecord" >
                                            <h1 v-html="resultSearch[key]['company'].nameRecord"></h1>
                                        </router-link>

                                        <h2 v-html="resultSearch[key]['company'].Title"  v-if="resultSearch[key]['company'].Module=='contacto'" ></h2>

                                        <router-link v-if="resultSearch[key]['company'].Module=='contacto'" :to="'/empresa/'+resultSearch[key]['company'].permalink_company" >
                                          <h3  v-html="resultSearch[key]['company'].CompanyName" ></h3>
                                        </router-link>

                                        <p v-html="resultSearch[key]['company'].NombreCategory+' '+resultSearch[key]['company'].NombreActivity" v-if="resultSearch[key]['company'].NombreCategory || resultSearch[key]['company'].NombreActivity" ></p>
                                        <p v-html="resultSearch[key]['company'].citiName"  ></p>
                                        <p v-html="resultSearch[key]['company'].Telefono1" ></p>
                                        <a :href="'http://'+resultSearch[key]['company'].URL" target="_blank"><h4 v-html="resultSearch[key]['company'].URL" ></h4></a>
                                    </div>
                                </div>
                            </div>

                            <div class="num-resultados">
                                <h5>{{ resultSearchCounter }} resultados</h5>
                            </div>
                        </div>

                        <div style="margin-top: 10px; margin-left: 50px; text-align: center;">
                          <ul class="pagination list-inline" style=" margin-top: 0px; padding-top: 0px; margin-bottom: 10px;">
                            <li>
                            <a :readonly="currentPage <= 0"  @click.prevent="currentPage=currentPage-1;pageNum(currentPage)"   >&laquo;</a></li>

                            <li v-for="value in (total_pages-1)" :class="(currentPage == value ) ? 'active' : '' "  v-if="total_pages && (typeof total_pages !== 'undefined' ) && (typeof resultSearchCounter !== 'undefined' ) && resultSearchCounter>0 && resultSearch && (value<10+currentPage  && value>=currentPage )"   ><a    @click.prevent="currentPage=value;pageNum(currentPage)" v-html="value"  ></a></li>
                            <li><a disabled="currentPage <= total_pages - 1" @click.prevent="currentPage=currentPage+1;pageNum(currentPage)"   v-if="resultSearchCounter>0 && resultSearch"   >&raquo;</a></li>
                          </ul>
                        </div>
                   </div>
                   <div class="col-md-4 animated slideInRight">
                        <div class="busqueda-contenido visible-lg visible-md">
                            <ul class="list-inline">
                                <li style="width: 77%;"><input v-model="simpleSearchInput" autocomplete="off" class="form-control"  placeholder="Buscar en Who's Who..."></li>
                                <li style="width: 10%;"><a  @click.prevent="simpleSearch" ><button class="busq"><i class="fa fa-search"></i></button></a></li>
                                <li style="width: 10%;"><button class="avanz"  data-toggle="collapse" data-target="#busqavanzada"><i class="fa fa-plus"></i></button></li>
                            </ul>
                        </div>
                        <div class="busq-avanzada">
                            <div id="busqavanzada" class="collapse">
                                <form class="form-horizontal" @submit.prevent="advanceSearch" method="get" >
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="contactoIn"  placeholder="Contacto...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <input class="form-control" v-model="empresaIn"  placeholder="Empresa...">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="country" v-model="countryIn"  >
                                                <option :value="0" selected >-- País --</option>
                                                <option  v-for="(country,index) in countries" v-html="country.NombreFM" :value="country.IdCountry"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="category" v-model="categoryIn" @change="getActivity()" >
                                                <option  :value="0"  selected >-- Categoría --</option>
                                                <option  v-for="(category,index) in categories" v-html="category.Nombre" :value="category.IdCompanyCategory"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <select class="form-control" name="activity" v-model="activityIn" >
                                                <option  :value="0"  selected >-- Actividad --</option>
                                                <option  v-for="(activity,index) in activities" v-html="activity.Nombre" :value="activity.IdCompanyActivity"></option>
                                            </select>
                                        </div>
                                    </div>
                                  </form>
                            </div>
                        </div>
                        <div class="banner">
                            <!--<img class="lateral-responsive" src="../assets/images/banner_lateral.png">-->
                        </div>
                   </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';

import axios from 'axios';

export default {
    name: 'Advancesearch',
    components: {},
    data() {
        return {
            resultSearch: [],
            AdvanceSearchInput: '',
            simpleSearchInput: '',
            countries: [],
            categories: [],
            activities: [],
            categoryIn: 0,
            contactoIn: '',
            empresaIn: '',
            countryIn: 0,
            activityIn: 0,

            resultSearchCounter: 0,

            currentPage: 1,
            query_rows: 10,
            total_pages: 0,
            pageSize: 10,
            page: 1,
            isMobile: false,
        };
    },
    created() {},
    methods: {
        moment: function() {
            return moment();
        },
        getContactsByAdvanceSearchWWFWS: async function(searchIN, pageIN) {
            this.currentPage = pageIN;

            await axios
                .post(resfulApi + 'getContactsByAdvanceSearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: searchIN,
                    page: pageIN,
                })
                .then(response => {
                    this.resultSearch = [];
                    this.resultSearchCounter = 0;
                    this.total_pages = 1;

                    if (
                        response.data.totalRecordsCont > 0 &&
                        response.data.result
                    ) {
                        console.log('enter to get records');
                        this.resultSearch = response.data.result;
                        this.resultSearchCounter =
                            response.data.totalRecordsCont;

                        this.total_pages = Math.ceil(
                            this.resultSearchCounter / this.query_rows
                        );

                        if (
                            (this.resultSearchCounter % this.query_rows) %
                            this.query_rows >
                            0
                        ) {
                            this.total_pages = this.total_pages + 1;
                        }
                    }

                    //this.resultSearch =response.data

                    this.$nextTick(function() {});
                });
        },
        simpleSearch: function(e) {
            if (this.simpleSearchInput) {
                this.$router.push('/busqueda/' + this.simpleSearchInput);
            }
        },
        getActivity: async function() {
            if (this.categoryIn) {
                await axios
                    .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        category: this.categoryIn,
                    })
                    .then(response => {
                        this.activities = response.data;

                        this.$nextTick(function() {});
                    });
            }
        },
        pageNum: async function(currPageIn) {
            var search =
                    this.contactoIn +
                    '_' +
                    this.empresaIn +
                    '_' +
                    this.countryIn +
                    '_' +
                    this.categoryIn +
                    '_' +
                    this.activityIn,
                page;
            await axios
                .post(resfulApi + 'getContactsByAdvanceSearchWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    search: search,
                    page: currPageIn,
                })
                .then(response => {
                    if (
                        response.data.totalRecordsCont > 0 &&
                        response.data.result
                    ) {
                        window.scrollTo(0, 0);
                        this.resultSearch = response.data.result;
                        this.resultSearchCounter =
                            response.data.totalRecordsCont;

                        this.total_pages = Math.ceil(
                            this.resultSearchCounter / this.query_rows
                        );

                        if (
                            (this.resultSearchCounter % this.query_rows) %
                            this.query_rows >
                            0
                        ) {
                            this.total_pages = this.total_pages + 1;
                        }
                    }
                });
        },
        getDataForm: async function() {
            await axios
                .post(resfulApi + 'getCountriesWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(response => {
                    this.countries = response.data.countries;
                    this.categories = response.data.categories;

                    this.$nextTick(function() {});
                });

            this.getActivity();
        },
        advanceSearch: async function(page) {
            this.currentPage = page;
            this.getContactsByAdvanceSearchWWFWS(
                this.contactoIn +
                    '_' +
                    this.empresaIn +
                    '_' +
                    this.countryIn +
                    '_' +
                    this.categoryIn +
                    '_' +
                    this.activityIn,
                page
            );
        },
        getDataModal: async function() {
            await axios
                .post(resfulApi + 'getCountriesWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(response => {
                    this.countries = response.data.countries;
                    this.categories = response.data.categories;

                    this.$nextTick(function() {});
                });

            this.getActivity();
        },
        getActivity: async function() {
            this.activityIn = 0;
            if (this.categoryIn) {
                await axios
                    .post(resfulApi + 'getActivitiesByCategoryWWFWS', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        category: this.categoryIn,
                    })
                    .then(response => {
                        this.activities = response.data;
                        this.$nextTick(function() {});
                    });
            }
        },
    },
    beforeMount() {},
    mounted: function() {
        $('body').removeClass('modal-open');
        this.isMobile = this.checkMobile();
        this.getContactsByAdvanceSearchWWFWS(this.$route.params.search, 1);

        var tmp = this.$route.params.search.split('_');

        if (tmp) {
            this.contactoIn = tmp[0];
            this.empresaIn = tmp[1];
            this.countryIn = tmp[2];
            this.categoryIn = tmp[3];
            this.activityIn = tmp[4];
        }

        this.getDataForm();
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filtro-negro a:hover {
    cursor: pointer;
}

a:hover {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Advancesearch.vue